"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "../../button";
import { UserAvatar } from "../../user-avatar";

interface UserProfileTriggerProps extends React.ComponentPropsWithoutRef<typeof Button> {
  initials: string;
  displayName: string;
  userTypeDisplay: string;
  avatarUrl?: string | null;
}

export const UserProfileTrigger = React.forwardRef<HTMLButtonElement, UserProfileTriggerProps>(
  function UserProfileTrigger(
    { initials, displayName, userTypeDisplay, avatarUrl, className, ...props },
    ref,
  ) {
    return (
      <Button
        ref={ref}
        variant="ghost"
        data-testid="user-profile-menu-trigger"
        className={
          "flex items-center space-x-3 px-3 py-2 h-10 hover:bg-accent transition-colors min-h-[44px] md:min-h-[48px] lg:min-h-[36px] md:px-4 lg:px-3" +
          (className ? ` ${className}` : "")
        }
        {...props}
      >
        {/* User Avatar */}
        <UserAvatar
          avatarUrl={avatarUrl}
          initials={initials}
          name={displayName}
          size="default"
          className="shadow-sm"
        />

        {/* User Info - Hidden on smaller screens */}
        <div className="hidden lg:block text-left min-w-0">
          <p className="text-sm font-medium text-foreground truncate">{displayName}</p>
          <p className="text-xs text-muted-foreground truncate">{userTypeDisplay}</p>
        </div>

        <ChevronDown className="h-4 w-4 text-muted-foreground hidden lg:block" />
      </Button>
    );
  },
);
